import firebase from 'firebase/app';
import 'firebase/firestore';
import store from '../store';
import { O_RDONLY } from 'constants';

const getFood = function() {
  return new Promise(async (resolveOuter, rejectOuter) => {
    try {      
        new Promise((resolve, reject) => {
          const stateFood = store.getters.allFood;
          if (stateFood.length == 0) {
            console.log('Service: Loading all food');
            loadAllFood()
              .then(fd => {
                console.log('Service: Committing food to store');
                store.commit('setFood', fd);
                resolve(fd);
              })
              .catch(error => reject(error));
          }
          else {
            console.log('Service: Loading all food', store.getters.allFood);
            resolve(store.getters.allFood);
          }
        })
        .then(food => {
          // Flatten groups for data table
          food.forEach(fd => {
            fd = setViewmodelFields(fd); // Viewmodel for the portion
          });
          //setTimeout(() => {}, 5000);
          console.log('Foodservice : getfood : outer : ', food)
          resolveOuter(food);
        })
    } catch (error) {
      rejectOuter(error);
    }
  });
}

const loadAllFood = async function() {
  const snapshot = await firebase.firestore().collection('weigh_less_food').get()
  return snapshot.docs.map(doc => { 
    // Add the id of the document to the object for updates
    return Object.assign({ id: doc.id}, doc.data());
  });
}
const deleteFood = function(id) {
  return new Promise((resolve, reject) => {
    try {  
      firebase.firestore().collection("weigh_less_food").doc(id).delete()
      .then(function(docRef) {
        console.log('Food deleted', id);
        store.commit('deleteFood', { id: id });        
        resolve(id);
    })
    .catch(function(error) {
      throw error;
    });
    }
    catch(error) {
      store.commit('showError', error)
      reject(error);
    }
  });
}

const updateFood = function(food) {
  var db = firebase.firestore();
  return new Promise((resolve, reject) => {
    try {

      // Deep copy ID
      let saveFood = cleanUpFood(food); // Remove unwanted properties
      // Unflatten groups
      unFlattenGroups(saveFood);
      db.collection("weigh_less_food").doc(food.id).set(saveFood)
      .then(function(docRef) {
        saveFood.id = food.id;
        let vmFood = setViewmodelFields(saveFood);
        //console.log('Food update', vmFood, saveFood);
        store.commit('updateFood', vmFood);        
        resolve(vmFood);
      })
      .catch(function(error) {
        throw error;
      });
    }
    catch(error) {
      store.commit('showError', error)
      reject(error);
    }
  });
}

// TODO: Clean up the different object mappings, it's ugly/hacky
const addFood = function(food) {
  var db = firebase.firestore();
  return new Promise((resolve, reject) => {
    try {
      let saveFood = cleanUpFood(food); // Remove unwanted properties
      // Unflatten groups
      unFlattenGroups(saveFood);

      db.collection("weigh_less_food").add(saveFood)
      .then(function(docRef) {
          console.log('Food added', docRef.id);
          food.id = docRef.id;
          food.g = saveFood.g; // HACK: Copy the groups
          store.commit('addFood', food);        
          resolve(food);
      })
      .catch(function(error) {
        throw error;
      });
    }
    catch(error) {
      store.commit('showError', error)
      reject(error);
    }
  });
}

// db.collection("weigh_less_food")
// .onSnapshot(function(querySnapshot) {
//   console.error('weigh_less_food changed');
//   var food = [];
//   querySnapshot.forEach(function(doc) {
//     food.push(doc.data());
//   });
// });

export default {
  addFood,
  getFood,
  updateFood,
  deleteFood
}

function setViewmodelFields(fd) {
  try {
    const groupObject = arrayToObject(fd.g);
    fd = Object.assign(fd, groupObject); // Groups
    return fd;
  } catch(error) {
    console.log(error, fd);
  };
}

function cleanUpFood(food) {
  let saveFood = JSON.parse(JSON.stringify(food));
  delete saveFood.id; // Don't store the ID
  return saveFood;
}

function unFlattenGroups(food) {
  food.g = [];
  let groups = ['Carbs', 'Milk', 'Fruit', 'Fat', 'Protein', 'Veg'];
  groups.forEach((g) => {
    if (food[g]) {
      food.g.push({
        n: g,
        p: food[g]
      });
      delete food[g];
    }
  });
}

const arrayToObject = (array) =>
array.reduce((obj, item) => {
  obj[item.n] = item.p
  return obj
}, {});

const CHOICES = [ { text: 'Best', value: 0 }, { text: 'Better', value: 1 }, { text: 'Breakout', value: 2 }, { text: 'Good', value: 3 }]